/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Select_Previous_EventInputs */

const en_shortcut_keys_desc_select_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the previous event in the list`)
};

const fr_shortcut_keys_desc_select_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner l'evenement precedent dans la liste`)
};

const de_shortcut_keys_desc_select_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie das vorherige Ereignis in der Liste aus.`)
};

const it_shortcut_keys_desc_select_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona l'evento precedente nell'elenco`)
};

const ru_shortcut_keys_desc_select_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите предыдущее событие в списке.`)
};

const es_shortcut_keys_desc_select_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el evento anterior en la lista`)
};

const zh_cn2_shortcut_keys_desc_select_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在列表中选择上一个事件`)
};

const ja_shortcut_keys_desc_select_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リスト内の前のイベントを選択する`)
};

const hi_shortcut_keys_desc_select_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूची में से पिछली घटना का चयन करें`)
};

const pt_pt2_shortcut_keys_desc_select_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o evento anterior na lista.`)
};

/**
* | output |
* | --- |
* | "Select the previous event in the list" |
*
* @param {Shortcut_Keys_Desc_Select_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_select_previous_event = /** @type {((inputs?: Shortcut_Keys_Desc_Select_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Select_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_select_previous_event(inputs)
	if (locale === "de") return de_shortcut_keys_desc_select_previous_event(inputs)
	if (locale === "it") return it_shortcut_keys_desc_select_previous_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_select_previous_event(inputs)
	if (locale === "es") return es_shortcut_keys_desc_select_previous_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_select_previous_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_select_previous_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_select_previous_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_select_previous_event(inputs)
	return en_shortcut_keys_desc_select_previous_event(inputs)
});